type PendingItem<E> = { event: E, reported?: boolean };

export class BufferedEventManager<E> {
	private buffer: E[] = [];
	private flushTimer: ReturnType<Window['setTimeout']>|undefined = undefined;

	public constructor(
		private readonly handler: (buffer: E[]) => void,
		private readonly maxBufferLength = 180, // The actual maximum for GA4 e-commerce events is 200. The 180 is just to give us a bit of safety margin
		private readonly timeout = 400 // This is in ms
	) {
		addEventListener('visibilitychange', () => {
			if (document.visibilityState === 'hidden') {
				this.flush();
			}
		});
		addEventListener('pagehide', this.flush);
	}

	public readonly enqueue = (item: PendingItem<E>) => {
		if (!item.reported) {
			item.reported = true;
			this.buffer.push(item.event);
			if (this.buffer.length >= this.maxBufferLength) { // The actual maximum is 200. The 180 is just to give us a bit of safety margin
				return this.flush();
			} else {
				clearTimeout(this.flushTimer);
				this.flushTimer = setTimeout(this.flush, this.timeout);
			}
		}
	}

	public readonly flush = () => {
		clearTimeout(this.flushTimer);
		if (this.buffer.length) {
			this.handler(this.buffer);
			this.buffer = [];
		}
	}
}
